import { render, staticRenderFns } from "./HbRadioGroup.vue?vue&type=template&id=3554b663&"
import script from "./HbRadioGroup.vue?vue&type=script&lang=js&"
export * from "./HbRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./HbRadioGroup.vue?vue&type=style&index=0&id=3554b663&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports